import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead, guardPage } from "../components/blog/BlogCategoryPage";
import { pageCount, postsForCategory } from "../components/blog/BlogListing";

const BASE_PATH = "/blog/seo";

export const Route = createFileRoute("/blog/seo/page/$page")({
  loader: ({ params }) => ({
    page: guardPage(BASE_PATH, params.page, pageCount(postsForCategory("seo").length)),
  }),
  head: ({ loaderData }) => categoryHead("seo", loaderData?.page ?? 2),
  component: CategoryPageRoute,
});

function CategoryPageRoute() {
  const { page } = Route.useLoaderData();
  return <BlogCategoryPage categoryKey="seo" page={page} />;
}
